module.exports = __webpack_public_path__ + "static/media/photo267.e1699330.jpg";